<template>
  <v-flex xs12>
    <non-member-message v-if="isVisible"></non-member-message>
  </v-flex>
</template>

<script>


import NonMemberMessage from "@/components/ChapterPage/NonMemberMessage/NonMemberMessage";

export default {
  name: 'ChampionsPage',

  components: {
    NonMemberMessage,
  },
  data: () => ({}),
  computed: {
    isVisible() {
      return this.$route.params.communityId === undefined;
    },
  },
};
</script>
